/* eslint-disable no-useless-concat */
/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment, useEffect, useState } from "react";
import { Fade } from "react-reveal";
import { toast, ToastContainer } from "react-toastify";
import { axiosRequest, refreshPage } from "../../../../api";
import { getUser } from "../../../utils/common";
import LoadingButton from "../../../LoadingButton";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  addToCartRequestActions,
  removeToCartRequestActions,
} from "../../../../store/cart/actions";
import { calculateTotalAmount, getActivePrice } from "../../../../utils/helper";
import ConfirmModel from "../../../model/confirmModel";
import { Button, Modal, Select } from "antd";
import Empty from '../../../../assets/images/Empty-cart.png';
import { getAllClientClientAction } from "../../../../store/client/actions";
import moment from "moment";
import { assignSubscriptionToClientAction } from "../../../../store/settings/actions";
import CreateClientForm from "../../../form/createClientForm";
// import "../../../pages/sales/index.css";
const Team_URL = "team?excludeTypes=ADMIN_A,CASHIER_C";
//
const { Option } = Select;

const Invoice = ({ isTablet }) => {
  const { cart, setting, client, auth } = useSelector((state) => state);
  const { cartId } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const todayDate = moment().format("YYYY-MM-DD");

  const [removeProductModel, setRemoveProductModel] = useState(false);
  const [removeServiceModel, setRemoveServiceModel] = useState(false);
  const [isClientModalOpen, setIsClientModalOpen] = useState(false);
  const [removeSubModel, setRemoveSubModel] = useState(false);
  const [productId, setProductId] = useState("");
  const [serviceId, setServiceId] = useState("");
  const [serviceToDelete, setServiceToDelete] = useState("");
  const [subscriptionToremove, setSubscriptionToremove] = useState("")
  const [hasAppointmentId, setHasAppointmentId] = useState("");
  const [Data, setData] = useState([]);
  const [enableLoading, setEnableLoading] = useState()

  const [deleDataModel, setDeleteDataModel] = useState(false);
  const [appointment, setAppointment] = useState([]);
  const [loading, setLoading] = useState(true);
  const id = appointment[0]?._id;
  const [open, setOpen] = useState(false);
  const handleDropDown = () => setOpen(!open);

  const user = getUser();
  const findRole = user[0]?.roles[0]?.permissions;
  const permissions = [];
  findRole?.map((item) => permissions?.push(item.permissions));

  const clientServices = cart?.selected?.data?.client?.subscription?.reference?.services

  // Check if client is walk-in (no bonuses)
  const isWalkInClient = cart?.selected?.data?.client?.clientType === "walkIn" || 
                         cart?.selected?.data?.client?.firstname === "Walk-in" ||
                         cart?.selected?.data?.client?._id === process.env.REACT_APP_WALK_IN_CLIENT_ID;

  // Calculate total visits from history and current cart
  const calculateTotalVisitsWithCurrent = () => {
    const history = cart?.selected?.data?.client?.bonusManagement?.clientHistory;
    if (!history || isWalkInClient) return { previousVisits: 0, currentCount: 0, totalVisits: 0, isTenthVisitBonus: false };
    
    let totalVisits = 0;
    for (const historyItem of history) {
      // Skip the total visit tracker itself
      if (historyItem.isTotalVisitTracker) continue;
      totalVisits += (historyItem.round * 10) + historyItem.count;
    }
    
    const currentCartServiceCount = cart?.selected?.data?.listOfService?.length || 0;
    const newTotalVisits = totalVisits + currentCartServiceCount;
    
    const previousMilestone = Math.floor(totalVisits / 10);
    const newMilestone = Math.floor(newTotalVisits / 10);
    const isTenthVisitBonus = newMilestone > previousMilestone;
    
    return {
      previousVisits: totalVisits,
      currentCount: currentCartServiceCount,
      totalVisits: newTotalVisits,
      isTenthVisitBonus: isTenthVisitBonus,
      nextMilestone: (newMilestone + 1) * 10
    };
  };

  const visitInfo = calculateTotalVisitsWithCurrent();
  
  // Calculate bonus amount (ALL services free if it's the 10th visit)
  const calculateBonusAmount = () => {
    if (isWalkInClient || !visitInfo.isTenthVisitBonus) return 0;
    
    // Calculate total of ALL services in cart
    let total = 0;
    for (const service of cart?.selected?.data?.listOfService || []) {
      total += parseFloat(service.amount) || 0;
    }
    return total;
  };
  
  const bonusAmount = calculateBonusAmount();
  const isTenthVisit = visitInfo.isTenthVisitBonus && bonusAmount > 0;

  const deleteModel = () => {
    let newState = !deleDataModel;
    setDeleteDataModel(newState);
  };
  
  const getTeamMember = () => {
    setLoading(true);
    axiosRequest
      .get(Team_URL)
      .then((response) => {
        setLoading(false);
        const result = response.data.data;
        setData(result);
      })
      .catch((error) => {
        console.log(error.message);
      });
  };
  
  const getClients = () => {
    getAllClientClientAction()(dispatch);
  };

  const handleRejectStatus = () => {
    const url = `appointment/cancel/${id}`;
    axiosRequest
      .put(url)
      .then((response) => {
        const result = response.data;
        const { status, message } = result;
        toast.success("Appointment rejected");
        setTimeout(() => {
          refreshPage();
        }, 500);
      })
      .catch((error) => {
        console.log(error);
        setTimeout(() => {
          refreshPage();
        }, 2000);
      });
  };

  useEffect(() => {
    getClients();
    getTeamMember();
  }, []);

  const isEmptyCart =
    cart?.selected?.data?.products?.length === 0 &&
    cart?.selected?.data?.listOfService?.length === 0 && !cart?.selected?.data?.Subscription

  const totalAmount = calculateTotalAmount(cart?.selected?.data ?? {}, clientServices);
  
  // Calculate final amount with both discount and bonus
  const calculateFinalAmount = () => {
    let amount = totalAmount;
    
    //// Apply discount first (if any)
    if (cart?.selected?.data?.discount > 0) {
      amount = amount - (amount * cart.selected.data.discount / 100);
    }
    
    // Then subtract bonus (ALL services free on 10th visit)
    if (!isWalkInClient && isTenthVisit) {
      amount = amount - (bonusAmount || 0);
    }
    
    // Add subscription if present
    if (cart?.selected?.data?.Subscription) {
      amount += getActivePrice(cart.selected.data.Subscription.sub_amount);
    }
    
    return amount > 0 ? amount : 0;
  };
  
  // Calculate discount amount for display
  const discountAmount = cart?.selected?.data?.discount > 0 
    ? (totalAmount * cart.selected.data.discount / 100) 
    : 0;
  
  // Check if this is a bonus visit
  const hasEligibleBonus = bonusAmount > 0;

  const showProductModal = (value) => {
    setRemoveProductModel(true);
    setProductId(value);
  };

  const showClientModal = () => {
    setIsClientModalOpen(true)
  }

  const handleCancel = () => {
    setIsClientModalOpen(false)
  }

  const hideProductModal = () => {
    setRemoveProductModel(false);
    setProductId("");
  };

  const showSubModal = (value) => {
    setRemoveSubModel(true);
    setSubscriptionToremove(value);
  };

  const hideSubModal = () => {
    setRemoveSubModel(false);
    setSubscriptionToremove("");
  };

  const showServiceModal = (value, service) => {
    setRemoveServiceModel(true);
    setServiceId(service?._id);
    setServiceToDelete(service?.servicename)
    setHasAppointmentId(value);
  };
  
  const hideServiceModal = () => {
    setRemoveServiceModel(false);
    setServiceToDelete("")
    setServiceId("")
  };

  const handleRemoveProduct = async () => {
    await removeToCartRequestActions(
      cartId,
      {
        productIdsToRemove: [productId],
      }, "Removed from the cart"
    )(dispatch);
    setProductId("");
    setRemoveProductModel(false);
  };

  const handleRemoveSubscription = async () => {
    await removeToCartRequestActions(
      cartId,
      {
        removeSubscription: subscriptionToremove,
      },
      "Removed from the cart"
    )(dispatch);
    setSubscriptionToremove("");
    setRemoveProductModel(false);
  };

  const handleRemoveService = async () => {
    await removeToCartRequestActions(
      cartId,
      { serviceIdsToRemove: [serviceId] }, `Removed from the cart`
    )(dispatch);
    setServiceId("");
    setServiceToDelete("")
    setRemoveServiceModel(false);
  };

  const handlerUpdateCart = async (field, value) => {
    setEnableLoading(field)
    if (auth?.token && cartId) {
      await addToCartRequestActions(auth?.token, cartId, {
        [field]: value,
      }, `${field} added Successfully`)(dispatch);
    }
  }

  const productToSell = cart?.selected?.data?.products?.map((d) => {
    return {
      productId: d?.productId?._id,
      quantity: d?.quantity,
    };
  });

  const handleCartPayment = async () => {
    setEnableLoading("done")
    const payload = {
      subscriptionId: cart?.selected?.data?.Subscription?._id,
      clientId: cart?.selected?.data?.client?._id,
    }
    if (cart?.selected?.data?.hasSubscription) {
      const res = await assignSubscriptionToClientAction(payload)(dispatch)
      if (res && auth?.token && cartId) {
        const isSold = await addToCartRequestActions(auth?.token, cartId, {
          amoutPaid: calculateFinalAmount(),
          status: "paid",
          productsToAdd: productToSell,
          bonusAllowed: bonusAmount
        }, "Done Successfully")(dispatch);
        if (isSold) {
          navigate(`/sales/details/${cartId}`);
        }
      }
    } else {
      if (auth?.token && cartId) {
        const isSold = await addToCartRequestActions(auth?.token, cartId, {
          amoutPaid: calculateFinalAmount(),
          status: "paid",
          productsToAdd: productToSell,
          bonusAllowed: bonusAmount
        }, "Done Successfully")(dispatch);
        if (isSold) {
          navigate(`/sales/details/${cartId}`);
        }
      }
    }
  };

  const clientOptions =
    client?.all?.data?.map((el) => ({
      value: el?._id,
      label: `${el?.firstname && el?.lastname
        ? `${el?.firstname} ${el?.lastname}`
        : el?.firstname || el?.lastname}`,
    })) || [];

  return (
    <>
      <ToastContainer />
      {/* ====================== Start::  deleteDataModel =============================== */}
      <Fade right>
        <div
          className={`min-h-full -mt-[27rem] -ml-[70%] w-screen z-50 bg-opacity-30 backdrop-blur-sm fixed flex items-center justify-center px-4 ${deleDataModel === true ? "block" : "hidden"
            }`}
        >
          <div className="bg-white w-1/2 shadow-2xl rounded-lg p-4">
            <div className="card-title w-full flex  flex-wrap justify-center items-center  ">
              <h1 className="font-bold text-sm text-center w-11/12">
                Reject Appointment
              </h1>
              <hr className=" bg-primary border-b w-full" />
            </div>
            <div className="card-body">
              <form className=" px-8">
                <div>
                  <h2 className="text-base pb-4 text-center">
                    Do you really want to Reject this Appointment??
                  </h2>
                </div>
                <div className="w-full flex justify-between">
                  <button
                    className="btn-white  shadow-none"
                    onClick={(e) => deleteModel(e.preventDefault())}
                  >
                    Cancel
                  </button>
                  <button
                    className="btn-black btn-s shadow-none"
                    onClick={handleRejectStatus}
                  >
                    Reject
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </Fade>
      {/* =========================== End::  deleteDataModel =============================== */}

      <Fragment>
        <div className="card">
          <div className="card-body">
            <h4 className="d-flex justify-content-between align-items-center mb-3">
              <span className="text-muted">Cart</span>
            </h4>
            <div>
              <span>Discount</span>
              <Select
                className="w-100 h-10"
                id="automatic-selection"
                value={cart?.selected?.data?.discount || ""}
                onChange={(value) => handlerUpdateCart("discount", value)}
              >
                {setting?.all?.data?.map((el, index) => (
                  <Option
                    value={el?.percentage}
                    key={index}
                    className="capitalize"
                  >
                    {el?.name}
                  </Option>
                ))}
                <Option
                  value={0}
                  className="capitalize"
                >
                  none
                </Option>
              </Select>
            </div>
            <hr />
            
            {/* Bonus Celebration Banner */}
            {!isWalkInClient && isTenthVisit && (
              <div className="bg-gradient-to-r from-green-500 to-green-600 text-white p-4 rounded-lg mb-4 text-center">
                <div className="text-2xl mb-2">🎉 CONGRATULATIONS! 🎉</div>
                <div className="text-lg font-bold">This is your 10th Visit!</div>
                <div className="text-md">ALL services in your cart are FREE today!</div>
                <div className="text-sm mt-2">Thank you for being a loyal customer</div>
              </div>
            )}
            
            {!isEmptyCart && (
              <ul className="list-group mb-3">
                {cart?.selected?.data?.products?.length > 0 &&
                  cart?.selected?.data?.products?.map((d) => (
                    <React.Fragment key={d?.productId?._id}>
                      <li className="list-group-item d-flex justify-content-between lh-condensed">
                        <div>
                          <h6 className="my-0">{d?.productId?.productname}</h6>
                        </div>
                        <div className="flex items-center space-x-4">
                          <span className="text-muted">
                            {`${d?.quantity
                              } x ${d?.productId?.amount?.toLocaleString()} RWF`}
                          </span>
                          <span
                            onClick={() => showProductModal(d?.productId?._id)}
                          >
                            <i className="fa fa-trash-o text-red-500 cursor-pointer"></i>
                          </span>
                        </div>
                      </li>
                      {removeProductModel && (
                        <ConfirmModel
                          name={d?.productId?.productName}
                          open={removeProductModel}
                          hideModal={hideProductModal}
                          onOk={handleRemoveProduct}
                          isLoading={cart?.isFetching}
                        />
                      )}
                    </React.Fragment>
                  ))}

                {
                  cart?.selected?.data?.listOfService?.length > 0 &&
                  cart?.selected?.data?.listOfService?.map((d) => (
                    <React.Fragment key={d?._id}>
                      <li className="list-group-item d-flex justify-content-between lh-condensed">
                        <div className="flex flex-col">
                          <span className="fs-14">
                            <strong className={isTenthVisit ? "line-through" : ""}>
                              {d?.servicename}
                            </strong>
                          </span>
                          {!isWalkInClient && isTenthVisit && (
                            <small className="text-green-600 text-xs mt-1 font-bold">
                              🎉 FREE on 10th Visit!
                            </small>
                          )}
                          {!isWalkInClient && !isTenthVisit && visitInfo.nextMilestone && (
                            <small className="text-gray-500 text-xs mt-1">
                              {visitInfo.nextMilestone - visitInfo.totalVisits} more visit(s) until FREE visit!
                            </small>
                          )}
                        </div>
                        <div className="flex items-center space-x-4">
                          <span
                            className="text-black"
                            style={{
                              textDecoration: isTenthVisit ? "line-through" : "none",
                              color: isTenthVisit ? "gray" : "inherit",
                            }}
                          >
                            {`${parseInt(d?.amount)?.toLocaleString()} Rwf`}
                          </span>
                          <span onClick={() => showServiceModal(d?._id, d)}>
                            <i className="fa fa-trash-o text-red-500 cursor-pointer"></i>
                          </span>
                        </div>
                      </li>
                      {removeServiceModel && (
                        <ConfirmModel
                          name={serviceToDelete}
                          open={removeServiceModel}
                          hideModal={hideServiceModal}
                          onOk={handleRemoveService}
                          isLoading={cart?.isFetching}
                        />
                      )}
                    </React.Fragment>
                  ))}

                {cart?.selected?.data?.Subscription && (
                  <React.Fragment>
                    <li className="list-group-item d-flex justify-content-between lh-condensed">
                      <div>
                        <span className="fs-14"><strong>{cart?.selected?.data?.Subscription?.name}</strong></span>
                        <small className="d-block fs-12">{cart?.selected?.data?.Subscription?.services?.length} Services Included</small>
                      </div>
                      <div className="flex items-center space-x-4">
                        <span className="text-black">{`${parseInt(
                          getActivePrice(
                            cart?.selected?.data?.Subscription?.sub_amount
                          )
                        )?.toLocaleString()} Rwf`}</span>
                        <span onClick={() => showSubModal(cart?.selected?.data?.Subscription?._id)}>
                          <i className="fa fa-trash-o text-red-500 cursor-pointer"></i>
                        </span>
                      </div>
                    </li>
                    {removeSubModel && (
                      <ConfirmModel
                        name={cart?.selected?.data?.Subscription?.name}
                        open={removeSubModel}
                        hideModal={hideSubModal}
                        onOk={handleRemoveSubscription}
                        isLoading={cart?.isFetching}
                      />
                    )}
                  </React.Fragment>
                )}

                {(cart?.selected?.data?.listOfService?.length > 0 ||
                  cart?.selected?.data?.products?.length > 0) && (
                    <>
                      <li className="list-group-item flex flex-col space-y-2">
                        {cart?.selected?.data?.listOfService?.length > 0 && (
                          <div className="flex items-center justify-between">
                            <span className="">Sub Total (Services)</span>
                            <span className={isTenthVisit ? "line-through text-gray-400" : ""}>
                              {`${totalAmount?.toLocaleString()} RWF`}
                            </span>
                          </div>
                        )}
                        
                        {/* Bonus Discount Line - 10th Visit ALL SERVICES FREE */}
                        {!isWalkInClient && isTenthVisit && (
                          <div className="flex items-center justify-between text-green-600 font-bold">
                            <span className="">🎉 10th VISIT BONUS - ALL SERVICES FREE! 🎉</span>
                            <span>{`- ${bonusAmount?.toLocaleString()} RWF`}</span>
                          </div>
                        )}
                        
                        {cart?.selected?.data?.Subscription && (
                          <div className="flex items-center justify-between">
                            <span className="">Membership</span>
                            <span>{`${getActivePrice(
                              cart?.selected?.data?.Subscription?.sub_amount
                            )?.toLocaleString()} RWF`}</span>
                          </div>
                        )}
                        
                        {cart?.selected?.data?.discount > 0 && (
                          <div className="flex items-center justify-between text-orange-600">
                            <span className="">Discount ({cart?.selected?.data?.discount}%)</span>
                            <span>{`- ${discountAmount?.toLocaleString()} RWF`}</span>
                          </div>
                        )}
                        
                        <div className="flex items-center justify-between border-t pt-2 mt-2 font-bold">
                          <span className="font-semibold text-lg">Total Amount</span>
                          <strong className={`text-lg ${isTenthVisit ? "text-green-600" : "text-gray-900"}`}>
                            {`${calculateFinalAmount()?.toLocaleString()} RWF`}
                          </strong>
                        </div>
                        
                        {!isWalkInClient && isTenthVisit && (
                          <div className="text-xs text-green-600 text-center mt-2 font-bold">
                            🎉 Congratulations! Your 10th visit is completely FREE! 🎉
                          </div>
                        )}
                        
                        {!isWalkInClient && !isTenthVisit && visitInfo.nextMilestone && (
                          <div className="text-xs text-gray-500 text-center mt-1">
                            💫 {visitInfo.nextMilestone - visitInfo.totalVisits} more visit(s) until your FREE bonus visit!
                            <br />
                            (Total visits: {visitInfo.totalVisits} / {visitInfo.nextMilestone})
                          </div>
                        )}
                        
                        {isWalkInClient && (
                          <div className="text-xs text-gray-500 text-center mt-1">
                            * Walk-in clients are not eligible for bonus discounts
                          </div>
                        )}
                      </li>
                    </>
                  )}
              </ul>
            )}
            {isEmptyCart && (
              <div className="flex justify-center items-center w-full mb-3">
                <img src={Empty} alt="empty cart" className='w-20 h-20' />
              </div>
            )}
            <hr />
            <div className="row">
              <div className="col-md-4">
                <label className=" text-black font-w500 text-sm">
                  Client
                </label>
                <Select
                  className="w-100 h-10"
                  showSearch
                  placeholder="Search by names"
                  optionFilterProp="label"
                  options={clientOptions}
                  value={cart?.selected?.data?.client?._id ?? ""}
                  onChange={(value) => handlerUpdateCart("client", value)}
                  required
                  disabled={cart?.isUpdating}
                  loading={cart?.isUpdating && enableLoading === "client"}
                  dropdownRender={(menu) => (
                    <div>
                      {menu}
                      <hr />
                      <Button
                        disabled={cart?.isUpdating}
                        style={{
                          backgroundColor: "#f0a907",
                          color: "white",
                          textAlign: "center",
                          width: "100%",
                        }}
                        onClick={showClientModal}
                        className="bg-[#f0a907] h-10 text-base text-white text-center w-full rounded-md"
                      >
                        + Add New Client
                      </Button>
                    </div>
                  )}
                />
              </div>
              <div className="col-md-4">
                <label className=" text-black font-w500 text-sm">
                  Payment Method
                </label>
                <Select
                  className="w-100 h-10"
                  id="automatic-selection"
                  value={cart?.selected?.data?.paymentMethod ?? ""}
                  onChange={(value) => handlerUpdateCart("paymentMethod", value)}
                  required
                  disabled={cart?.isUpdating}
                  loading={cart?.isUpdating && enableLoading === "paymentMethod"}
                >
                  {["Momo", "Card", "Cash", "Subscription"].map((el, index) => (
                    <Option value={el} key={index} className="capitalize">
                      {el}
                    </Option>
                  ))}
                </Select>
              </div>
              <div className="col-md-4">
                <label className=" text-black font-w500 text-sm">
                  Barber
                </label>
                <Select
                  className="w-100 h-10"
                  id="automatic-selection"
                  value={cart?.selected?.data?.barber?._id ?? ""}
                  onChange={(value) => handlerUpdateCart("barber", value)}
                  required
                  disabled={cart?.isUpdating}
                  loading={cart?.isUpdating && enableLoading === "barber"}
                >
                  {Data.map((el, index) => (
                    <Option value={el?._id} key={index} className="capitalize">
                      {`${el?.firstname} ${el?.lastname}`}
                    </Option>
                  ))}
                </Select>
              </div>
            </div>
            <br />
            <hr className="mb-4" />
            <div className="row">
              {permissions.indexOf("approve-sales") !== -1 && (
                <div className="col-md-9 text-sm flex items-center justify-center mx-auto">
                  {cart?.isUpdating && enableLoading === "done" ? (
                    <LoadingButton />
                  ) : (
                    <button
                      className={`btn-black text-sm btn-block ${(!cart?.selected?.data?.paymentMethod ||
                        !cart?.selected?.data?.client ||
                        !cart?.selected?.data?.barber) ||
                        (cart?.selected?.data?.products?.length < 1 && 
                         cart?.selected?.data?.listOfService?.length < 1 && 
                         !cart?.selected?.data?.hasSubscription) || 
                        cart?.selected?.data?.status === "paid"
                        ? "cursor-not-allowed opacity-50"
                        : ""
                      }`}
                      disabled={
                        (!cart?.selected?.data?.paymentMethod &&
                          !cart?.selected?.data?.client &&
                          !cart?.selected?.data?.barber) ||
                        (cart?.selected?.data?.products?.length < 1 && 
                         cart?.selected?.data?.listOfService?.length < 1 && 
                         !cart?.selected?.data?.hasSubscription) || 
                        cart?.selected?.data?.status === "paid"
                      }
                      onClick={handleCartPayment}
                    >
                      {isTenthVisit ? "Complete FREE Visit" : "Approve Sales"}
                    </button>
                  )}
                </div>
              )}
            </div>
          </div>
          {!isTablet && (
            <div
              className={
                !open
                  ? "hidden"
                  : "w-40 rounded-lg border bg-red-500 justify-end buttom-0"
              }
              onClick={handleDropDown}
            >
              <ul className="space-y-3 p-2">
                <li className="font-medium">
                  <button
                    className="flex cursor-pointer text-white items-center transform transition-colors duration-200 border-transparent"
                    onClick={() => {
                      deleteModel();
                    }}
                  >
                    Reject Appointment
                  </button>
                </li>
              </ul>
            </div>
          )}
        </div>
      </Fragment>
      <Modal
        title={
          <h1 className="text-[#030229] text-lg py-2">Add a new client</h1>
        }
        width={800}
        open={isClientModalOpen}
        onCancel={handleCancel}
        footer={null}
      >
        <CreateClientForm onCancel={handleCancel} />
      </Modal>
    </>
  );
};

export default Invoice;